import React, { useEffect, useCallback, useState } from 'react';
import IconButton from '@mui/material/IconButton';
import ArrowDropDownCircleIcon from '@mui/icons-material/ArrowDropDownCircle';
import { Box } from '@mui/material';

type Props = {
    enableButtonBottom?: boolean;
}
const StickyButton: React.FC<Props> = (props: Props) => {
    const [stickyActive, setStickyActive] = useState<boolean>(false);


    const scrollToTop = useCallback(() => {
        const contentContainer = document.getElementById("contentContainer");
        if (contentContainer) {
            contentContainer.scrollTo({ top: 0, behavior: "smooth" });
        }
    }, []);
    const scrollToButton = useCallback(() => {
        const contentContainer = document.getElementById("contentContainer");
        if (contentContainer) {
            contentContainer.scrollTo({ top: contentContainer.scrollHeight, behavior: "smooth" });
        }
    }, []);

    useEffect(() => {
        const handleScroll = (evt: Event) => {
            const target = evt.target as HTMLElement;
            if (target.scrollTop >= 2) {
                setStickyActive(true);
            } else {
                setStickyActive(false);
            }
        };

        const contentContainer = document.getElementById("contentContainer");
        if (contentContainer) {
            contentContainer.addEventListener("scroll", handleScroll);
            return () => {
                contentContainer.removeEventListener("scroll", handleScroll);
            };
        }
    }, []);

    return (
        <Box sx={{
            opacity: .5,
            display: stickyActive ? 'block' : 'none',
            position: 'fixed',
            bottom: 50,
            right: { xs: -10, lg: 30 },
            zIndex: 9999,
        }}>
            <span className='flex flex-col gap-y-0'>
                <IconButton
                    onClick={scrollToTop}
                >
                    <ArrowDropDownCircleIcon sx={{ transform: "rotate(180deg)", fontSize: 35 }} />
                </IconButton>
                {props.enableButtonBottom && (
                    <IconButton
                        onClick={scrollToButton}
                    >
                        <ArrowDropDownCircleIcon sx={{ fontSize: 35 }} />
                    </IconButton>
                )}
            </span>
        </Box>
    );
};

export default StickyButton;
